/** Preserve constraint validation and submit events; form.submit() bypasses both. */
export function installFormCompatibility() {
  if (typeof HTMLFormElement.prototype.requestSubmit === "function") return;
  Object.defineProperty(HTMLFormElement.prototype, "requestSubmit", { configurable: true, writable: true,
    value(this: HTMLFormElement, submitter?: HTMLElement | null) {
      if (!(this instanceof HTMLFormElement)) throw new TypeError("requestSubmit requires a form");
      if (submitter != null) {
        const button = submitter instanceof HTMLButtonElement && submitter.type === "submit";
        const input = submitter instanceof HTMLInputElement && ["submit", "image"].includes(submitter.type);
        if (!button && !input) throw new TypeError("The submitter is not a submit button");
        if ((submitter as HTMLButtonElement).form !== this) throw new DOMException("The submitter does not belong to this form", "NotFoundError");
        submitter.click(); return;
      }
      const button = document.createElement("button"); button.type = "submit"; button.hidden = true;
      this.appendChild(button);
      try { button.click(); } finally { button.remove(); }
    },
  });
}
